import './StudiesCenter.scss'

import * as lottie_building from '../../lotties/StudiesCenter/building.json'

import Desplegable from '../../components/Desplegable/Desplegable'
import ExternalLink from '../../components/ExternalLink/ExternalLink'
import Blocks from '../../components/Icons/Blocks'
import Forum from '../../components/Icons/Forum'
import ListItem from '../../components/ListItem/ListItem'
// Lotties
import Lottie from 'react-lottie'
import { animated } from 'react-spring'
import { ModalContainer } from '../../components/Containers/ModalContainer'
import { SectionContainer } from '../../components/Containers/SectionContainer'
import MapCard from '../../components/MapCard/MapCard'
import VerticalWaves from '../../components/VerticalWaves/VerticalWaves'
import { contacts } from '../../data'

// Maps

const StudiesCenter = ({ color = 'green', secondary = 'brown', scrollRight, modalHandling, closeModal, section, parallax, setLock }) => {
  // Lotties

  // https://lottiefiles.com/22469-campus-library-school-building-office-mocca-animation
  const lottieBuilding = (
    <Lottie
      options={{
        loop: false,
        autoplay: true,
        animationData: lottie_building.default,
        rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
      }}
      width={150}
      height={150}
      speed={0.5}
    />
  )

  // Desplegables area
  const adminStructure = (
    <div className="desplegable-container admin-structure">
      {lottieBuilding}
      <p>
        Los centros (Facultades y EPS) tienen una estructura administrativa que <span className="bold">se centraliza en la secretaría</span> (también llamada
        Oficina de Gestión de Alumnos, de Gestión de Grado o Administración) donde se atienden todas las cuestiones que no están relacionadas con la docencia y
        la evaluación, por ejemplo, la <span className="bold">gestión de matrícula, pagos, turnos de clase, expedientes</span>, etc.
      </p>
    </div>
  )

  const academicStructure = (
    <div className="desplegable-container academic-structure">
      <p>
        Además, los centros también tienen una estructura académica, que <span className="bold">se encarga de</span> todo lo que tiene que ver con{' '}
        <span className="bold">los estudios</span> propiamente dichos.
      </p>
      <p>
        <span className="bold">La dirección está a cargo de los equipos decanales</span> (o, en el caso de la EPS, del equipo de dirección) encabezados por el
        decano/a o director/a. Sus miembros forman parte del profesorado y <span className="bold">son elegidos por la comunidad universitaria</span> para
        atender áreas específicas organizadas en los vicedecanatos o subdirecciones que puedes consultar en la sección de órganos de gobierno de la página web
        de tu centro.
      </p>
      <p>
        <span className="bold">Todo el profesorado</span>, a su vez, <span className="bold">está vinculado a distintos departamentos</span> que se dedican a
        áreas específicas de conocimiento y organizan e imparten la docencia de las asignaturas de su especialidad (por ejemplo, la asignatura de Mecánica
        Cuántica del Grado en Física la imparten profesores y profesoras del Departamento de Física Teórica de la Facultad de Ciencias).
      </p>
    </div>
  )

  const vicerrector = (
    <div className="desplegable-container vicerrector">
      <ul className="kite-list">
        <li>
          <ListItem color={color} kiteColor={secondary}>
            Vicerrectorado de <span className="bold">Campus y Sostenibilidad</span>
          </ListItem>
        </li>
        <li>
          <ListItem color={color} kiteColor={secondary}>
            Vicerrectorado de <span className="bold">Compromiso Social y Cultura</span>
          </ListItem>
        </li>
        <li>
          <ListItem color={color} kiteColor={secondary}>
            Vicerrectorado de <span className="bold">Estudiantes</span>
          </ListItem>
        </li>
        <li>
          <ListItem color={color} kiteColor={secondary}>
            Vicerrectorado de <span className="bold">Estudios de Grado y Calidad de los Estudios</span>
          </ListItem>
        </li>
        <li>
          <ListItem color={color} kiteColor={secondary}>
            Vicerrectorado de <span className="bold">Estudios de Posgrado</span>
          </ListItem>
        </li>
        <li>
          <ListItem color={color} kiteColor={secondary}>
            Vicerrectorado de <span className="bold">Formación Permanente y Empleabilidad</span>
          </ListItem>
        </li>
        <li>
          <ListItem color={color} kiteColor={secondary}>
            Vicerrectorado de <span className="bold">Internacionalización</span>
          </ListItem>
        </li>
        <li>
          <ListItem color={color} kiteColor={secondary}>
            Vicerrectorado de <span className="bold">Innovación y Transferencia</span>
          </ListItem>
        </li>
        <li>
          <ListItem color={color} kiteColor={secondary}>
            Vicerrectorado de <span className="bold">Personal Docente e Investigador</span>
          </ListItem>
        </li>
        <li>
          <ListItem color={color} kiteColor={secondary}>
            Vicerrectorado de <span className="bold">Planificación y Estrategia</span>
          </ListItem>
        </li>
        <li>
          <ListItem color={color} kiteColor={secondary}>
            Vicerrectorado de <span className="bold">Política Científica</span>
          </ListItem>
        </li>
      </ul>

      <ExternalLink color={secondary} secondary={color} url="https://www.uam.es/uam/organos-gobierno/equipo-de-gobierno-uam" text="¡Ponles cara!" />
    </div>
  )

  const governmentStructure = (
    <div className="desplegable-container government">
      <p>
        El Equipo de Gobierno <span className="bold">marca la dirección estratégica</span> y persigue los objetivos fijados, pero{' '}
        <span className="bold">las decisiones más importantes son tomadas de manera democrática</span> por órganos colegiados —es decir, compuestos por una
        pluralidad de personas de la Universidad— donde <span className="bold">todos los colectivos de la UAM tienen voz</span>.
      </p>
      <p>De manera simplificada, la estructura podría representarse así:</p>

      <div className={`university-council structure-schema ${color}`}>
        <div className="icon-container">
          <Forum color="green" />
        </div>
        <h4 className="uppercase urbana text-semi-normal">Claustro universitario</h4>
        <p>Máximo órgano de representación. Está formado por más de 300 miembros y se encarga de supervisar la gestión.</p>

        <div className="government-council">
          <div className="icon-container">
            <Blocks color="green" />
          </div>
          <h4 className="uppercase urbana text-semi-normal">Consejo de gobierno</h4>
          <p>El principal órgano de gobierno de la universidad. Aprueba las líneas estratégicas y establece procedimientos de aplicación.</p>

          <div className="inner-container">
            <div className="block">
              <h4 className="uppercase urbana text-semi-normal">Juntas de centro</h4>
              <p>Guían y aprueban las estrategias de gestión de cada centro, supervisando la actuación de su dirección o equipo decanal.</p>
            </div>

            <div className="block">
              <h4 className="uppercase urbana text-semi-normal">Consejo social</h4>
              <p>
                Es el órgano de relación con la sociedad. Le corresponde la supervisión de las actividades económicas y la aprobación de nuevas titulaciones
                oficiales.
              </p>
            </div>

            <div className="block">
              <h4 className="uppercase urbana text-semi-normal">Consejo de estudiantes</h4>
              <p>El Consejo de Estudiantes (CEUAM) está formado por representantes de estudiantes de cada centro de la UAM.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )

  // Modals area
  const location = (
    <ModalContainer secondary={secondary} color={color} title="Localización" onClick={() => closeModal()}>
      <div className="location-diagram">
        <img src="/svg/meet-studies-center/location-diagram.png" alt="" />
      </div>
      <p>
        El campus de la UAM cuenta con <span className="bold">ocho centros</span> distribuidos en <span className="bold">dos sedes</span>: la de Medicina (junto
        al Hospital La Paz), en la que se encuentra la Facultad de Medicina; y la sede de Cantoblanco, donde se ubican el resto de facultades –Ciencias,
        Ciencias Económicas y Empresariales, Derecho, Filosofía y Letras, Formación de Profesorado y Educación, Psicología– y la Escuela Politécnica Superior.
      </p>
      <div className="questions-container-list">
        <Desplegable secondary={secondary} color={color} title="Plano del campus UAM">
          <MapCard color={color} secondary={secondary} text="Plano campus UAM" map={'/maps/plano_uam.pdf'} contacts={contacts} />
        </Desplegable>
        <Desplegable secondary={secondary} color={color} title="Planos de los centros UAM">
          <MapCard color={color} secondary={secondary} text="Edificio Biológicas" map={'/maps/EDIFICO_BIOLOGICAS.pdf'} />
          <MapCard color={color} secondary={secondary} text="Escuela Politécnica Superior" map={'/maps/ESCUELA_POLITECNICA_SUPERIOR.pdf'} />
          <MapCard color={color} secondary={secondary} text="Escuela Politécnica Superior (Edif. C)" map={'/maps/ESCUELA_POLITECNICA_SUPERIOR_EDIF.C.pdf'} />
          <MapCard color={color} secondary={secondary} text="Facultad de Ciencias Económicas" map={'/maps/FACULTAD_CIENCIAS_ECONOMICAS_Y_EMPRESARIALES.pdf'} />
          <MapCard color={color} secondary={secondary} text="Facultad de Ciencias" map={'/maps/FACULTAD_CIENCIAS.pdf'} />
          <MapCard color={color} secondary={secondary} text="Facultad de Medicina" map={'/maps/FACULTAD_DE_MEDICINA.pdf'} />
          <MapCard color={color} secondary={secondary} text="Facultad de Derecho" map={'/maps/FACULTAD_DERECHO.pdf'} />
          <MapCard color={color} secondary={secondary} text="Facultad de Derecho (Edif. Jurídicas)" map={'/maps/FACULTAD_DERECHO_EDIFICIO_JURIDICAS.pdf'} />
          <MapCard color={color} secondary={secondary} text="Facultad de Filosofía y Letras" map={'/maps/FACULTAD_FILOSOFIA_Y_LETRAS.pdf'} />
          <MapCard color={color} secondary={secondary} text="Facultad de Profesorado y Educación" map={'/maps/FACULTAD_PROFESORADO_Y_EDUCACION.pdf'} />
          <MapCard color={color} secondary={secondary} text="Facultad de Psicología" map={'/maps/FACULTAD_PSICOLOGIA.pdf'} />
        </Desplegable>
      </div>
    </ModalContainer>
  )

  const centerOrganised = (
    <ModalContainer secondary={secondary} color={color} title="¿Cómo está organizado tu centro?" onClick={() => closeModal()}>
      <p>
        Si consigues un ejemplar físico de esta guía (pásate por UAM Estudiantes) encontrarás una sección con los planos de tu centro que te ayudará a
        familiarizarte con la distribución de aulas y la localización de las zonas comunes más importantes.
      </p>
      <p>Además de la organización espacial, debes conocer cómo funciona la gestión de tu centro, que tiene una parte administrativa y otra académica.</p>

      <div className="questions-container-list">
        <Desplegable secondary={secondary} color={color} title="Estructura administrativa">
          {adminStructure}
        </Desplegable>
        <Desplegable secondary={secondary} color={color} title="Estructura académica">
          {academicStructure}
        </Desplegable>
      </div>
    </ModalContainer>
  )

  const uamGovernment = (
    <ModalContainer secondary={secondary} color={color} title="El Gobierno de la UAM" onClick={() => closeModal()}>
      <p>
        Como puedes imaginar, tu centro de estudios solo es una pequeña parte de la Universidad. Del mismo modo que todos los miembros de una Facultad eligen al
        equipo de personas que administran el centro, cada cuatro años la comunidad universitaria al completo elige al Rector o Rectora, que es la máxima
        autoridad académica de la Universidad y quien nombra al resto del Equipo de Gobierno de la Universidad.
      </p>
      <p>
        A este pertenecen los/as vicerrectores/as <span className="bold">responsables de áreas específicas de trabajo</span>. Actualmente, existen los
        siguientes vicerrectorados:
      </p>

      {vicerrector}

      <div className="questions-container-list">
        <Desplegable secondary={secondary} color={color} title="Estructura de gobierno">
          {governmentStructure}
        </Desplegable>
      </div>
    </ModalContainer>
  )

  const items = [
    { key: 'location', content: location, title: 'Localización' },
    { key: 'center-organised', content: centerOrganised, title: '¿Cómo está organizado tu centro?' },
    { key: 'uam-government', content: uamGovernment, title: 'El gobierno de la UAM' }
  ]

  const Splash = (
    <>
      <div className="logo-back">
        <img src="/splash/svg/StudiesCenter_logo_back.svg" alt="" />
      </div>
      <animated.div className="logo-main" style={{ transform: parallax.logo_main(section) }}>
        <img src="/splash/svg/StudiesCenter_logo_main.svg" className="illustration" alt="" />
        <img src="/splash/png/StudiesCenter.png" className="image" alt="" />
      </animated.div>
      <div className="logo-front">
        <VerticalWaves color={secondary} />
      </div>
    </>
  )

  return (
    <SectionContainer
      // Section
      className={'StudiesCenter'}
      title={'Conoce tu centro de estudios'}
      // General
      color={color}
      secondary={secondary}
      items={items}
      setLock={setLock}
      section={section}
      // Mobile
      handleMobileModal={modalHandling}
      scrollRight={scrollRight}
    >
      {Splash}
    </SectionContainer>
  )
}

export default StudiesCenter
